// @flow
import { PRODUCT_CHILDCARES } from 'Client/cms/toolkit/constants';
import { ProductChildcaresLine } from 'Components/lines/product-childcares-line/ProductChildcaresLine';
import { productChildcaresResolver } from './productChildcares.resolver';

export const productChildcaresDescriptor = {
  name: PRODUCT_CHILDCARES,
  component: ProductChildcaresLine,
  resolve: productChildcaresResolver.resolve,
};
